import { render, staticRenderFns } from "./SpreadsheetView.vue?vue&type=template&id=2aa0ced8&scoped=true&"
import script from "./SpreadsheetView.vue?vue&type=script&lang=ts&"
export * from "./SpreadsheetView.vue?vue&type=script&lang=ts&"
import style0 from "./SpreadsheetView.vue?vue&type=style&index=0&id=2aa0ced8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa0ced8",
  null
  
)

export default component.exports